import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import NotLoggedInRoute from "../Components/Common/NotLoggedInRoute";
import UploadFile from "../Components/UploadFile";
import MainLayout from "../Components/Layouts/MainLayout";

const RouterComponent = ({ children }) => (
  <Router>
    <Switch>
      <NotLoggedInRoute path="/upload-file" header="UploadFile">
        <MainLayout header="Upload File">
          <UploadFile />
        </MainLayout>
      </NotLoggedInRoute>
      <Route path="/">
        <Redirect to="/upload-file" />
      </Route>
    </Switch>
    {children}
  </Router>
);

export default RouterComponent;
